const RETURN_COOKIE = 'ic_return';
const MAX_AGE_SECONDS = 60 * 60; // 60 minutes

export function isSafeReturnPath(path) {
  if (!path || typeof path !== 'string') return false;
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.includes('\n') || path.includes('\r') || path.includes('\\')) return false;
  if (path.includes('://')) return false;
  return true;
}

function readCookie(name) {
  const parts = `; ${document.cookie}`.split(`; ${name}=`);
  if (parts.length < 2) return null;
  return decodeURIComponent(parts.pop().split(';').shift() || '');
}

export function setReturnPath(path) {
  if (!isSafeReturnPath(path)) return;
  document.cookie = `${RETURN_COOKIE}=${encodeURIComponent(path)}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
}

export function peekReturnPath() {
  const value = readCookie(RETURN_COOKIE);
  return isSafeReturnPath(value) ? value : null;
}

export function consumeReturnPath() {
  const value = peekReturnPath();
  document.cookie = `${RETURN_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax`;
  return value;
}

export function saveCurrentReturnPath() {
  const path = `${window.location.pathname}${window.location.search || ''}`;
  if (path === '/login' || path === '/sso' || path.startsWith('/login?') || path.startsWith('/sso?')) {
    return;
  }
  setReturnPath(path);
}
